module.exports = __webpack_public_path__ + "src/assets/img/12-months.16b457cc.svg";